<template>
  <div>
    <b-overlay :show="busy" no-wrap>
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 text-light rounded">
          <b-spinner
            style="width: 3rem; height: 3rem"
            variant="primary"
            class="mr-1"
            label="Large Spinner"
          ></b-spinner>
          <strong class="title-freight pt-1">
            {{ $t("button.saving") }}...
          </strong>
        </div>
        <div v-else-if="isLoading" class="text-center p-4 text-light rounded">
          <b-spinner
            style="width: 3rem; height: 3rem"
            variant="primary"
            class="mr-1"
            label="Large Spinner"
          ></b-spinner>
          <strong class="title-freight pt-1">
            {{ $t("button.loading") }}...
          </strong>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        ></div>
      </template>
    </b-overlay>

    <b-card :title="locals('report.rider_perf')">
      <b-row>
        <b-col md="12">
          <div class="d-flex justify-content-end"></div>
        </b-col>
      </b-row>
      <b-row class="pt-2">
        <b-col cols="12" class="mb-2">
          <b-row>
            <b-col md="3">
              <b-form-group
                :label="locals('inquiry.estimate_delivery_date')"
                label-for="i-date"
                class="title-freight"
              >
                <flat-pickr
                  class="form-control"
                  :config="{ mode: 'range', dateFormat: 'd/m/Y' }"
                  v-model="dataFilter.datDate"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="Rider ผู้รับงาน"
                label-for="i-accept-by"
                class="title-freight"
              >
                <v-select
                  id="i-accept-by"
                  v-model="dataFilter.strRider"
                  :placeholder="locals('select.placeholder')"
                  label="strDsName"
                  :options="listRider"
                  :reduce="(val) => val.strDsName"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                :label="locals('inquiry.company_name')"
                label-for="i-company"
                class="title-freight"
              >
                <v-select
                  id="i-company"
                  v-model="dataFilter.intCustomerId"
                  :placeholder="locals('select.placeholder')"
                  label="strDsName"
                  :options="custOption"
                  :reduce="(val) => val.intDsId"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label-for="i-request-type"
                class="title-freight"
                :label="locals('inquiry.type')"
              >
                <v-select
                  id="i-request-type"
                  input-id="i-request-type"
                  :clearable="true"
                  v-model="dataFilter.strJobType"
                  label="title"
                  :options="job_type"
                >
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <b-form-group
                label-for="i-origin"
                class="title-freight"
                :label="locals('inquiry.origin_port')"
              >
                <b-form-input
                  id="i-origin"
                  v-model="dataFilter.strOriginalPort"
                  maxlength="100"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label-for="i-dest"
                class="title-freight"
                :label="locals('inquiry.destination_port')"
              >
                <b-form-input
                  id="i-dest"
                  v-model="dataFilter.strDestPort"
                  maxlength="100"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label-for="i-remark"
                :label="locals('inquiry.doc_detail')"
                class="title-freight"
              >
                <b-form-input
                  id="i-remark"
                  v-model="dataFilter.strRemark"
                  maxlength="100"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                :label="locals('inquiry.status')"
                label-for="i-status"
                class="title-freight"
              >
                <v-select
                  id="i-status"
                  :clearable="true"
                  v-model="dataFilter.intStatusId"
                  :placeholder="locals('select.placeholder')"
                  input-id="i-status"
                  label="title"
                  :options="status"
                  :reduce="(val) => val.Id"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col class="d-flex justify-content-center">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1 custom-search"
            pill
            @click="onSearch"
          >
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">{{ $t("button.search") }}</span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            variant="outline-secondary"
            pill
            @click="onClear"
          >
            <feather-icon icon="RefreshCwIcon" class="mr-50" />
            <span class="align-middle">{{ $t("button.clear") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-card :title="locals('report.report')">
      <b-row class="pt-2">
        <b-col md="12">
          <b-col md="12">
            <b-table :fields="columns0" :items="rows0" responsive>
              <template #thead-top="data">
                <b-tr>
                  <b-th variant="secondary"></b-th>
                  <b-th
                    style="background-color: #3f51b5; color: white"
                    colspan="7"
                    class="text-center"
                  >
                    {{ $t("report.total") }}
                  </b-th>
                </b-tr>
              </template>
              <template #head(strLastAcceptBy)="">
                <div class="text-nowrap" style="font-size: 14px">
                  {{ $t("report.messenger") }}
                </div>
              </template>
              <template #head(intAccept)="">
                <div class="text-nowrap" style="font-size: 14px">
                  {{ $t("report.accept") }}
                </div>
              </template>
              <template #head(intDelivered)="">
                <div class="text-nowrap" style="font-size: 14px">
                  {{ $t("report.delivered") }}
                </div>
              </template>
              <template #head(intFail)="">
                <div class="text-nowrap" style="font-size: 14px">
                  {{ $t("report.fail") }}
                </div>
              </template>
              <template #head(intCompleted)="">
                <div class="text-nowrap" style="font-size: 14px">
                  {{ $t("report.completed") }}
                </div>
              </template>
              <template #head(intIncomp)="">
                <div class="text-nowrap" style="font-size: 14px">
                  {{ $t("report.incompletd") }}
                </div>
              </template>
              <template #head(intReturn)="">
                <div class="text-nowrap" style="font-size: 14px">
                  {{ $t("report.return") }}
                </div>
              </template>
              <template #head()="data">
                <div class="text-nowrap" style="font-size: 14px">
                  {{ data.label }}
                </div>
              </template>
              <template #cell(strLastAcceptBy)="data">
                <div style="width: 200px; font-size: 14px">
                  {{ data.value }}
                </div>
              </template>
              <template #cell()="data">
                <div style="width: 70px; font-size: 14px">{{ data.value }}</div>
              </template>
            </b-table>
          </b-col>
        </b-col>
      </b-row>
    </b-card>

    <b-card :title="locals('msg.detail')">
      <b-row class="pt-2">
        <b-col md="12">
          <vue-good-table
            :columns="columns"
            :rows="rows"
            :search-options="{
              enabled: false,
            }"
            :pagination-options="{
              enabled: true,
              perPage: pageLength,
            }"
            styleClass="vgt-table condensed"
          >
            <!-- Slot: Table Column -->
            <template slot="table-column" slot-scope="props">
              <span
                v-if="props.column.label === 'ชื่อแมสเซนเจอร์'"
                class="text-nowrap"
              >
                {{ $t("report.messenger") }}
              </span>
              <span
                v-else-if="props.column.label === 'สถานะ'"
                class="text-nowrap"
              >
                {{ $t("inquiry.status") }}
              </span>
              <span
                v-else-if="props.column.label === 'ชื่อลูกค้า'"
                class="text-nowrap"
              >
                {{ $t("inquiry.customer_name") }}
              </span>
              <span
                v-else-if="props.column.label === 'ประเภทงาน'"
                class="text-nowrap"
              >
                {{ $t("inquiry.type") }}
              </span>
              <span
                v-else-if="props.column.label === 'สถานที่รับ'"
                class="text-nowrap"
              >
                {{ $t("inquiry.origin_port") }}
              </span>
              <span
                v-else-if="props.column.label === 'สถานที่จัดส่ง'"
                class="text-nowrap"
              >
                {{ $t("inquiry.destination_port") }}
              </span>
              <span
                v-else-if="props.column.label === 'กำหนดจัดส่ง'"
                class="text-nowrap"
              >
                {{ $t("inquiry.delivery_time") }}
              </span>
              <span
                v-else-if="props.column.label === 'ผู้สร้าง'"
                class="text-nowrap"
              >
                {{ $t("inquiry.create_by") }}
              </span>
              <span
                v-else-if="props.column.label === 'วันที่สร้าง'"
                class="text-nowrap"
              >
                {{ $t("inquiry.create_date") }}
              </span>
              <span
                v-else-if="props.column.label === 'ผู้แก้ไข'"
                class="text-nowrap"
              >
                {{ $t("inquiry.update_by") }}
              </span>
              <span
                v-else-if="props.column.label === 'วันที่แก้ไข'"
                class="text-nowrap"
              >
                {{ $t("inquiry.update_date") }}
              </span>
              <span
                v-else-if="props.column.label === 'วันที่เริ่มดำเนินการ'"
                class="text-nowrap"
              >
                {{ $t("inquiry.first_delivered_date") }}
              </span>
              <span
                v-else-if="props.column.label === 'วันที่ดำเนินการเสร็จ'"
                class="text-nowrap"
              >
                {{ $t("inquiry.last_delivered_date") }}
              </span>   
              <span v-else>
                {{ props.column.label }}
              </span>
            </template>
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field === 'strStatus'">
                <div class="text-center">
                  <b-badge :variant="statusVariant2(props.row.strStatus)">
                    {{ props.row.strStatus }}
                  </b-badge>
                </div>
              </span>
            </template>
            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                  <span class="text-nowrap"> Showing 1 to </span>
                  <b-form-select
                    v-model="pageLength"
                    :options="['5', '10', '25']"
                    class="mx-1"
                    @input="
                      (pageLength) =>
                        props.perPageChanged({
                          currentPerPage: pageLength,
                        })
                    "
                  />
                  <span class="text-nowrap">
                    of {{ props.total }} entries
                  </span>
                </div>
                <div>
                  <b-pagination
                    :value="1"
                    :total-rows="props.total"
                    :per-page="pageLength"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="
                      (pageLength) =>
                        props.pageChanged({
                          currentPage: pageLength,
                        })
                    "
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
              </div>
            </template>
          </vue-good-table>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Ripple from "vue-ripple-directive";
import { VueGoodTable } from "vue-good-table";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import {
  BTable,
  BTr,
  BTh,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BPagination,
  BBadge,
  BFormSelect,
  BFormRadio,
  VBModal,
  VBTooltip,
  BSpinner,
  BOverlay,
  BFormCheckbox,
} from "bootstrap-vue";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";

import Service from "@/@API/cDropdown";
import ReqService from "@/@API/cRequest";

export default {
  directives: {
    "b-modal": VBModal,
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    BTable,
    BTr,
    BTh,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BCard,
    BInputGroup,
    vSelect,
    BInputGroupAppend,
    BButton,
    flatPickr,
    VueGoodTable,
    BPagination,
    BBadge,
    BFormSelect,
    BFormRadio,
    BSpinner,
    BOverlay,
    BFormCheckbox,
  },
  setup() {
    const { t } = useI18nUtils();
    return { t };
  },
  computed: {
    statusVariant2() {
      const statusColor2 = {
        Draft: "light-info",
        Submit: "light-info",
        Accept: "light-primary",
        Delivered: "light-success",
        "Delivery-Failed": "light-danger",
        Completed: "light-success",
        "In-Completed": "light-primary",
        Return: "light-warning",
      };
      return (table_status2) => statusColor2[table_status2];
    },
  },
  data() {
    return {
      busy: true,
      processing: false,
      isLoading: true,
      dataFilter: {
        intCustomerId: "",
        strCustomerName: "",
        strInqJobNo: "",
        intStatusId: "",
        strStatus: "",
        datDate: "",
        datStartDate: "",
        datEndDate: "",
        strOriginalPort: "",
        strDestPort: "",
        strRemark: "",
        strJobType: "",
        strRider: "",
      },
      custOption: [
        { strDsName: "Loading...", intDsId: 1 }, 
      ],
      TestOptions: [
        {
          intDsId: 1,
          strDsDesc: "TEST",
        },
        {
          intDsId: 99,
          strDsDesc: "อื่น ๆ",
        },
      ],
      listRider: [
        {
          intDsId: 1,
          strDsDesc: "TEST",
        },
        {
          intDsId: 99,
          strDsDesc: "อื่น ๆ",
        },
      ],
      job_type: [
        { title: "รับเอกสาร", Id: 1 },
        { title: "ส่งเอกสาร", Id: 2 },
      ],
      ori_status: [
        { title: "Accept", Id: 5, lang: "en_US" },
        { title: "Delivered", Id: 6, lang: "en_US" },
        { title: "Delivery-Failed", Id: 7, lang: "en_US" },
        { title: "Completed", Id: 8, lang: "en_US" },
        { title: "In-Completed", Id: 9, lang: "en_US" },
        { title: "Return", Id: 10, lang: "en_US" },
        { title: "รับงาน", Id: 5, lang: "th_TH" },
        { title: "นำส่งเอกสาร", Id: 6, lang: "th_TH" },
        { title: "ส่งเอกสารไม่สำเร็จ", Id: 7, lang: "th_TH" },
        { title: "เสร็จสิ้น", Id: 8, lang: "th_TH" },
        { title: "ดำเนินการไม่สำเร็จ", Id: 9, lang: "th_TH" },
        { title: "ขอคืนงาน", Id: 10, lang: "th_TH" },
      ],
      status: [],
      table_status2: [
        {
          0: "Draft",
          1: "Submit",
          2: "Accept",
          3: "Delivery-Failed",
          4: "In-Completed",
          5: "Return",
          6: "Completed",
          7: "Delivered",
        },
        {
          0: "light-info",
          1: "light-info",
          2: "light-primary",
          3: "light-danger",
          4: "light-primary",
          5: "light-warning",
          6: "light-success",
          7: "light-success",
        },
      ],
      pageLength0: 5,
      pageLength: 5,
      dir: false,
      columns0: [
        {
          label: "ชื่อแมสเซนเจอร์",
          key: "strLastAcceptBy",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "*รวม*",
          key: "intAll",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "รอดำเนินการ",
          key: "intAccept",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ส่งเอกสารแล้ว",
          key: "intDelivered",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "นำส่งเอกสารไม่สำเร็จ",
          key: "intFail",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ดำเนินการเสร็จ",
          key: "intCompleted",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ดำเนินการไม่สำเร็จ",
          key: "intIncomp",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "คืนเข้าระบบ",
          key: "intReturn",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      rows: [
        {
          strLastAcceptBy: "Rider1",
          strStatus: "Accept",
        },
        {
          strLastAcceptBy: "Rider2",
          strStatus: "Accept",
        },
        {
          strLastAcceptBy: "Rider1",
          strStatus: "Accept",
        },
        {
          strLastAcceptBy: "Rider2",
          strStatus: "Delivered",
        },
      ],
      rows0: [,],
      columns: [
        {
          label: "ชื่อแมสเซนเจอร์",
          field: "strLastAcceptBy",
          width: "200px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Request Job no.",
          field: "strRQMJobNo",
          width: "200px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ชื่อลูกค้า",
          field: "strCustomerName",
          width: "250px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "กำหนดจัดส่ง",
          field: "datOrderDateDMY",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "สถานะ",
          field: "strStatus",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ประเภทงาน",
          field: "strJobType",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "สถานที่รับ",
          field: "strRecvLocation",
          width: "500px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "สถานที่จัดส่ง",
          field: "strDestLocation",
          width: "500px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ผู้สร้าง",
          field: "strCreatedBy",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "วันที่สร้าง",
          field: "datCreatedDateDMY",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ผู้แก้ไข",
          field: "strUpdatedBy",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "วันที่แก้ไข",
          field: "datUpdatedDateDMY",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "วันที่เริ่มดำเนินการ",
          field: "datLastAcceptDateDMY",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "วันที่ดำเนินการเสร็จ",
          field: "datLastDeliveredDateDMY",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      rows: [],
    };
  },
  mounted() {
    localStorage.setItem("request-id", -1);
    this.getDefault();
    this.onClear();
  },
  methods: {
    getDefault() {
      let lang = localStorage.getItem("language");
      let newstatus = [];
      newstatus = this.ori_status.filter((b) => b.lang == lang);
      this.status = newstatus;

      Service.getAdminPageDropdown({})
        .then((response) => {
          this.custOption = [];
          response.data.lstCustomer.forEach((cc) => {
            this.custOption.push(cc);
          });
          this.listRider = [];
          response.data.lstRider.forEach((ff) => {
            this.listRider.push(ff);
          });
          //console.log(response.data);
          //this.busy = false;
          //this.isLoading = false;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    btnPrintPdf(index, Id) {
      window.open(
        process.env.VUE_APP_API_BASE_URL +
          "api/v1/pdf/getFormRequestPdf?intRequestId=" +
          Id +
          "&strMode=" +
          "-",
        "_blank"
      );
    },
    onSearch() {
      if (
        this.dataFilter.intCustomerId != "" &&
        this.dataFilter.intCustomerId != null
      ) {
        let currCust = this.custOption.find(
          (c) => c.intDsId === this.dataFilter.intCustomerId
        );
        this.dataFilter.strCustomerName = currCust.strDsName;
      }
      if (
        this.dataFilter.intStatusId != "" &&
        this.dataFilter.intStatusId != null
      ) {
        let sta = this.ori_status.find(
          (c) => c.Id === this.dataFilter.intStatusId
        );
        this.dataFilter.strStatus = sta.title;
      }

      if (this.dataFilter.datDate != "") {
        let result = this.dataFilter.datDate.substring(0, 10);
        let result2 = this.dataFilter.datDate.substring(13, 24);
        // const myStartDate = moment(result, "YYYY-MM-DD").toDate();
        const myStartDate = moment(result, "DD/MM/YYYY").format("YYYY-MM-DD");
        const myEndDate = moment(result2, "DD/MM/YYYY").format("YYYY-MM-DD");
        this.dataFilter.datStartDate = myStartDate;
        this.dataFilter.datEndDate = myEndDate;
        //console.log(myStartDate);
        //console.log(myEndDate);
      }

      this.busy = true;
      this.isLoading = true;
      ReqService.getRequestReport(this.dataFilter)
        .then((response) => {
          console.log(response.data);
          this.busy = false;
          this.isLoading = false;
          let lang = localStorage.getItem("lang");
          this.rows = response.data;
          this.rows0 = [];
          this.rows.forEach((q) => {
            q.datOrderDateDMY = q.datOrderDate
              ? moment(q.datOrderDate).format("DD/MM/YYYY HH:mm")
              : null;
            q.datCreatedDateDMY = q.datCreatedDate
              ? moment(q.datCreatedDate).format("DD/MM/YYYY HH:mm")
              : null;
            q.datUpdatedDateDMY = q.datUpdatedDate
              ? moment(q.datUpdatedDate).format("DD/MM/YYYY HH:mm")
              : null;
            q.datLastAcceptDateDMY = q.datLastAcceptDate
              ? moment(q.datLastAcceptDate).format("DD/MM/YYYY HH:mm")
              : null;
            q.datLastDeliveredDateDMY = q.datLastDeliveredDate
              ? moment(q.datLastDeliveredDate).format("DD/MM/YYYY HH:mm")
              : null;
            let recvtext = "";
            recvtext =
              q.strRecvLocationName +
              " " +
              q.strRecvAddrName +
              " " +
              q.strRecvSubDistrict +
              " " +
              q.strRecvDistrict +
              " " +
              q.strRecvProvince +
              " " +
              q.strRecvPostCode;
            if (q.strRecvLocationNote != "" && q.strRecvLocationNote != null) {
              recvtext = recvtext + " " + q.strRecvLocationNote;
            }
            recvtext = recvtext + " " + q.strRecvContactName;
            recvtext = recvtext + " " + q.strRecvContactTelNo;
            q.strRecvLocation = recvtext;

            let desttext = "";
            desttext =
              q.strDestLocationName +
              " " +
              q.strDestAddrName +
              " " +
              q.strDestSubDistrict +
              " " +
              q.strDestDistrict +
              " " +
              q.strDestProvince +
              " " +
              q.strDestPostCode;
            if (q.strDestLocationNote != "" && q.strDestLocationNote != null) {
              desttext = desttext + " " + q.strDestLocationNote;
            }
            desttext = desttext + " " + q.strDestContactName;
            desttext = desttext + " " + q.strDestContactTelNo;
            q.strDestLocation = desttext;

            if ((q.intJobTypeId = 1)) {
              q.strJobType = "รับเอกสาร";
            }
            if ((q.intJobTypeId = 2)) {
              q.strJobType = "ส่งเอกสาร";
            }
          });

          if (this.rows.length > 0) {
            this.rows.forEach((row) => {
              let rider = this.findOrCreateRider(row.strLastAcceptBy);
              rider.intAll += 1;
              if (row.strStatus === "Accept") {
                rider.intAccept += 1;
              } else if (row.strStatus === "Delivered") {
                rider.intDelivered += 1;
              } else if (row.strStatus === "Delivery-Failed") {
                rider.intFail += 1;
              } else if (row.strStatus === "Completed") {
                rider.intCompleted += 1;
              } else if (row.strStatus === "In-Completed") {
                rider.intIncomp += 1;
              } else if (row.strStatus === "Return") {
                rider.intReturn += 1;
              }
            });
          }
        })
        .catch((error) => {
          this.busy = false;
          this.isLoading = false;
          console.log("error", error);
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Something was wrong",
                icon: "FrownIcon",
                variant: "danger",
                text: "Something was wrong : " + error,
              },
            },
            {
              position: "top-center",
            }
          );
        });
    },
    findOrCreateRider(riderName) {
      let rider = this.rows0.find((r) => r.strLastAcceptBy === riderName);
      if (!rider) {
        rider = {
          strLastAcceptBy: riderName,
          intAll: 0,
          intAccept: 0,
          intDelivered: 0,
          intFail: 0,
          intReturn: 0,
          intCompleted: 0,
          intIncomp: 0,
        };
        this.rows0.push(rider);
      }
      return rider;
    },
    onEdit(index, Id) {
      this.$router.replace({ name: "request-form" }).then(() => {
        localStorage.setItem("request-id", Id);
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "แก้ไขเอกสาร",
              icon: "EditIcon",
              variant: "warning",
              text: "กำลังแก้ไขเอกสาร",
            },
          },
          {
            position: "top-center",
          }
        );
      });
    },
    onDelete(index, Id) {
      let lang = localStorage.getItem("language");

      let tttitle = "Confirm Delete";
      let msg = "Do you want to delete this request?";
      let b1 = "Delete";
      let b2 = "Close";

      if (lang == "th_TH") {
        tttitle = "ยืนยันการลบ";
        msg = "คุณต้องการยืนยันลบเอกสารนี้ใช่หรือไม่ ?";
        b1 = "ลบ";
        b2 = "ปิด";
      }

      this.$bvModal
        .msgBoxConfirm(msg, {
          title: tttitle,
          size: "sm",
          modalClass: "modal-danger",
          okVariant: "danger",
          okTitle: b1,
          cancelTitle: b2,
          cancelVariant: "outline-warning",
          hideHeaderClose: false,
          //centered: true,
        })
        .then((value) => {
          this.busy = true;
          this.processing = true;
          console.log(value);
          if (value) {
            ReqService.getResponseDeleteRequest({ intRequestId: Id })
              .then((response) => {
                this.busy = false;
                this.processing = false;
                if (
                  response.data == "ไม่พบรายชื่อ" ||
                  response.data == "ไม่พบเอกสาร" ||
                  response.data == "ไม่สามารถลบได้"
                ) {
                  this.$toast(
                    {
                      component: ToastificationContent,
                      props: {
                        title: "Something was wrong",
                        icon: "FrownIcon",
                        variant: "danger",
                        text: response.data,
                      },
                    },
                    {
                      position: "top-center",
                    }
                  );
                } else {
                  this.rows.splice(index, 1);
                  this.$toast(
                    {
                      component: ToastificationContent,
                      props: {
                        title: "ลบข้อมูล",
                        icon: "XIcon",
                        variant: "success",
                        text: "ลบสำเร็จ",
                      },
                    },
                    {
                      position: "top-center",
                    }
                  );
                }
              })
              .catch((error) => {
                this.busy = false;
                this.processing = false;
                console.log("error", error);
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "Something was wrong",
                      icon: "FrownIcon",
                      variant: "danger",
                      text: "Something was wrong : " + error,
                    },
                  },
                  {
                    position: "top-center",
                  }
                );
              });
          }
        });
    },
    onClear() {
      this.busy = true;
      this.isLoading = true;

      this.dataFilter = {
        intCustomerId: "",
        strCustomerName: "",
        strInqJobNo: "",
        intStatusId: "",
        strStatus: "",
        datDate: "",
        datStartDate: "",
        datEndDate: "",
        strOriginalPort: "",
        strDestPort: "",
        strRemark: "",
        strJobType: "",
        strRider: "",
      };

      let today = moment().format("DD/MM/YYYY");
      let tomorrow = moment().add(1, "days").format("DD/MM/YYYY");
      this.dataFilter.datDate = [today, tomorrow];

      setTimeout(() => {
        this.onSearch();
      }, 2000);
    },
    locals(key) {
      return this.t(key);
    },
  },
};
</script>

<style lang="scss">
@import "../../@core/scss/vue/libs/vue-select.scss";
@import "../../@core/scss/vue/libs/vue-flatpicker.scss";
@import "../../@core/scss/vue/libs/vue-good-table.scss";
</style>
